import React from 'react';
import { useSelector } from 'react-redux';
import { AlertTriangle, Info } from 'lucide-react';

const LimitedAccessMessage = () => {
  const { user } = useSelector(state => state.user);
  
  if (!user || user.is_main_vendor) {
    return null;
  }
  
  const userPermissions = user?.permissions || [];
  
  // Check if user has only deal-related permissions
  const dealPermissions = [
    "View_Deals",
    "Create_Offer", 
    "Edit_Offer", 
    "Delete_Offer", 
    "Blast_Deal"
  ];
  
  const otherPermissions = [
    "View_Partners",
    "Create_Partner", 
    "Edit_Partner", 
    "Delete_Partner",
    "Redeem_Offers",
    "Redeem_Edit",
    "Redeem_Delete",
    "View_Reports_Analytics",
    "View_Subscription",
    "Purchase_Subscription",
    "View_Subscription_History",
    "Role_View",
    "Role_Create",
    "Role_Edit",
    "Role_Delete"
  ];
  
  const hasOnlyDealPermissions = userPermissions.length > 0 && 
    userPermissions.every(perm => dealPermissions.includes(perm)) &&
    !userPermissions.some(perm => otherPermissions.includes(perm));
  
  if (!hasOnlyDealPermissions) {
    return null;
  }
  
  return (
    <div className="p-4 mb-6 bg-blue-50 rounded-lg border border-blue-200">
      <div className="flex items-start space-x-3">
        <Info className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <h3 className="mb-1 text-sm font-medium text-blue-800">
            Limited Access Notice
          </h3>
          <p className="text-sm text-blue-700">
            You currently have limited access to the system. You can manage deals and access the dashboard. 
            Use the "Manage Your Deals" link in the sidebar to view and manage your offers. Contact your administrator if you need additional permissions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default LimitedAccessMessage; 